<template>
  <svg
    class="star-logo"
    viewBox="0 0 90.1 90.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g class="branch b1"><rect class="is-red" x="42.5" y="0" width="5.2" height="40.1" /></g>
    <g class="branch b2"><rect class="is-red" x="42.5" y="50.3" width="5.2" height="39.9" /></g>
    <g class="branch b3"><rect class="is-yellow" x="8.2" y="62.4" width="34.3" height="5.1" transform="translate(-38.5 37) rotate(-45)" /></g>
    <g class="branch b4"><rect class="is-yellow" x="22.8" y="8.3" width="5.1" height="34.3" transform="translate(-10.6 25.4) rotate(-45)" /></g>
    <g class="branch b5"><rect class="is-yellow" x="47.8" y="22.8" width="34.2" height="5.1" transform="translate(1.1 53.3) rotate(-45)" /></g>
    <g class="branch b6"><rect class="is-yellow" x="62.3" y="47.9" width="5.1" height="34.2" transform="translate(-26.9 65) rotate(-45)" /></g>
    <g class="branch b7"><rect class="is-red" x="50.1" y="42.5" width="40.1" height="5.2" /></g>
    <g class="branch b8"><rect class="is-red" x="0" y="42.7" width="39.9" height="5" /></g>
  </svg>
</template>

<script>
export default {
  name: 'StarLogo'
}
</script>

<style lang="scss" scoped>
.star-logo {
  display: block;

  .is-red { fill: $red; }
  .is-yellow { fill: $yellow; }
}
</style>
